<div class="pos-r">
  <div class="padding-16" *ngIf="gpCheckLoading">
    <app-loader [size]="'small'" [position]="'reset'"></app-loader>
  </div>
  <a
    style="display: none"
    class="link link--dotted-blue-dark"
    (click)="checkGlobalProblem()"
    *ngIf="ticket.ticket_type && ticket.ticket_type.id !== 4 && !gpCheckLoading && !gpCheckFirstLoading && !(ticket.hd_ticket_status.id === 194 && ticket.ticket_status.id === 12)"
  >
    Проверить ГП
  </a>
  <div class="grid grid--gap-4" *ngIf="gpCheckError && !gpCheckLoading">
    <div class="grid__box grid__box--size-min">
      <a class="link link--dotted-red-dark" [ngbPopover]="statusPopContent" placement="bottom" triggers="manual" #p2="ngbPopover" (click)="toggleWithStatusContext(p2)">Ошибка</a>
    </div>
    <div class="grid__box grid__box--size-min" (click)="checkGlobalProblem()">
      <app-icon [glyph]="'update'" [size]="'16'" [class]="'icon--va-middle'" [color]="'gray-dark'"></app-icon>
    </div>
  </div>
  <div *ngIf="!gpCheckError && !gpCheckLoading">
    <div class="grid grid--gap-4" *ngIf="gpCheckData && gpCheckData.gp">
      <div class="grid__box grid__box--size-min">
        <app-icon [glyph]="'triangle-warning'" [size]="'18'" [class]="'icon--va-top'" [color]="'pink'"></app-icon>
      </div>
      <div class="grid__box grid__box--size-min" (click)="checkGlobalProblem()">
        <a class="link" [routerLink]="['/', TICKETS_PATHS.ticketLink, ticket.id]">Есть</a>
      </div>
    </div>
    <div *ngIf="gpCheckData && !gpCheckData.gp">Нет</div>
  </div>
</div>

<ng-template #statusPopContent>
  <div class="w-320">
    <app-message [type]="'error'">
      <div message-content>Неизвестная ошибка. Повторите попытку через некоторое время. При повторении ошибки' свяжитесь с техподдержкой системы.</div>
    </app-message>
  </div>
</ng-template>
